import api from "../../api/services/axiosService";
import { DOCTOR_TATVA, USER_MANAGEMENT } from "../../envConstants";

const baseUrl: any = { customBaseUrl: DOCTOR_TATVA };
const userBaseUrl: any = { customBaseUrl: USER_MANAGEMENT, isTShots: true };

export const getSpecialities = async function () {
  let res = {};
  try {
    res = await api.get(`/api/v1/profile/specialities`, baseUrl);
  } catch (e) {
    console.error("Error while fetching specialities: ", e);
  }
  return res;
};

export const getCities = async function (q: string, countryId: number) {
  let res = {};
  console.log("[pwa] getCities", { q, countryId });
  try {
    res = await api.get(`/user/tatva/city?q=${q}&countryId=${countryId}`, userBaseUrl);
  } catch (e) {
    console.error("Error while fetching cities: ", e);
  }
  return res;
};

export const getQualifications = async function (q: string, promoCode: string, countryId: number) {
  let res = {};
  console.log("[pwa] getQualifications", { q, countryId, access_code: promoCode || "(none)" });
  try {
    res = await api.get(`/user/tatva/qualification?q=${q}&countryId=${countryId}${promoCode ? `&access_code=${promoCode}` : ""}`, userBaseUrl);
  } catch (e) {
    console.error("Error while fetching qualifications: ", e);
  }
  return res;
};

export const getBanners = async function (b2cId: string) {
  let res = {};
  try {
    res = await api.get(`/user/tatva/banners?b2c_id=${b2cId}`, userBaseUrl);
  } catch (e) {
    console.error("Error while fetching banners: ", e);
  }
  return res;
};

export const getPediaDoctorDetails = async function (mblNo: string) {
  let res = {};
    try {
      res = await api.post(`/user/tatva/v3/check`, {}, {...userBaseUrl, isTShots: false});
    } catch (e) {
      console.error("Error while fetching specialities: ", e);
    }
  return res;
}

export const applyPharmaCode = async function (body: any) {
  let res:any = {};
  try {
    res = await api.post(`/user/tatva/refer-code`, body, userBaseUrl);
  } catch (e) {
    console.error(e);
  }
  return res;
}

export const updatePediaCityQualification = async function (body: any) {
  let res:any = {};
  try {
    res = await api.post(`/user/tatva/v2/geo`, body, {...userBaseUrl, isTShots: false});
  } catch (e) {
    console.error(e);
  }
  return res;
}

export const pediaActiveSessions = async function (b2c: string) {
  let res = {};
  if(b2c) {
    try {
      res = await api.get(`/user/tatva/active-sessions?page=0&size=10&b2c=${b2c}`,  userBaseUrl);
    } catch (e) {
      console.error("Error while fetching active sessions: ", e);
    }
  }
  return res;
}

// Resolves undefined on failure so the caller does not treat a failed removal as done.
export const removePediaActiveSessionById = async function (id: any) {
  let res: any = undefined;
  if(id) {
    try {
      res = await api.get(`/user/tatva/manual-device-removal?deviceId=${id}`,  userBaseUrl);
    } catch (e) {
      console.error("Error while removing active session: ", e);
    }
  }
  return res;
}

export const updateSpeciality = async function (
  mobileNumber: any,
  payload: any
) {
  let res = {};
  try {
    res = await api.put(`/api/v1/profile/${mobileNumber}`, payload, baseUrl);
  } catch (e) {
    console.error("Error while updating speciality: ", e);
  }
  return res;
};

export const getProfile = async function (
  mobileNumber: any,
) {
  let res = {};
  try {
    res = await api.get(`/api/v1/profile/${mobileNumber}`, baseUrl);
  } catch (e) {
    console.error("Error while updating speciality: ", e);
  }
  return res;
};




